import { h, FunctionalComponent } from "preact";
import { AutodataCustomEventTypes } from "../../../autodata/src/ts/types";
import { FormattedResult } from "../ts/types";

import QuestionInlineView from "@common/components/QuestionInlineView";

interface Props {
  results: FormattedResult[];
  currentPage: number;
  searchText: string;
}

const Results: FunctionalComponent<Props> = ({
  results,
  currentPage,
  searchText,
}) => {
  return (
    <ul className="results">
      {results.map(result => (
        <li className="result">
          <QuestionInlineView
            {...result}
            onClick={() =>
              dispatchEvent(
                new CustomEvent(AutodataCustomEventTypes.ON_CLICK_RESULT, {
                  detail: {
                    dataEvent: {
                      category: "faq|result",
                      action: "openQuestion",
                      label: result.title,
                      faqThematic: result.thematicId,
                      faqCategory: result.categoryId,
                      faqQuestion: result.questionId,
                      value: currentPage,
                      faqKeyword: searchText,
                    },
                  },
                })
              )
            }
          />
        </li>
      ))}
    </ul>
  );
};

export default Results;
